<div class="cdw-export-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">{{ data.dialogTitle || 'Export for Reporting' }}</h2>
    <button
      type="button"
      class="dialog-close-button"
      (click)="onCancel()"
      aria-label="Close dialog"
    >
      <lib-cdw-icon icon="close"></lib-cdw-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="dialog-content" [formGroup]="exportForm">
    <!-- Section heading -->
    <div class="export-section-heading">Export {{ data.exportName }} Information</div>

    <!-- Export scope info -->
    <div class="export-scope-info">
      <ng-container *ngIf="data.scopeLabel; else defaultScopeLabel">
        {{ data.scopeLabel }}
      </ng-container>
      <ng-template #defaultScopeLabel>
        Exporting <strong>{{ itemCount | number }}</strong> items
        ({{ currentScope === 'selected' ? 'selected' : 'all' }})
        with <strong>{{ columnCount }}</strong> columns.
      </ng-template>
    </div>

    <!-- File name -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>File Name</mat-label>
      <input matInput formControlName="fileName" />
      <mat-error *ngIf="exportForm.get('fileName')?.hasError('invalidFileName')">
        File name must be under 100 characters and cannot contain \ / : * ? " &lt; &gt; |
      </mat-error>
    </mat-form-field>

    <!-- Rows to export -->
    <mat-form-field *ngIf="!data.hideScopeSelector" appearance="outline" class="full-width">
      <mat-label>Rows to export</mat-label>
      <mat-select formControlName="exportScope">
        <mat-option
          *ngFor="let opt of scopeOptions"
          [value]="opt.value"
          [disabled]="opt.disabled"
        >
          {{ opt.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Export format -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Export format</mat-label>
      <mat-select formControlName="format">
        <mat-option
          *ngFor="let opt of formatOptions"
          [value]="opt.value"
          [disabled]="opt.disabled"
        >
          <span
            [matTooltip]="opt.tooltip || ''"
            [matTooltipDisabled]="!opt.tooltip"
            class="option-label"
          >{{ opt.label }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Cell count warning -->
    <div *ngIf="cellCountWarning" class="cell-count-warning" [class.exceeded]="cellCountExceeded">
      <lib-cdw-icon [icon]="cellCountExceeded ? 'error' : 'warning'"></lib-cdw-icon>
      <span>{{ cellCountWarning }}</span>
    </div>

    <!-- Recipients -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Share exported file with (add each email on a new line)</mat-label>
      <textarea matInput formControlName="recipients" rows="3"></textarea>
      <mat-error *ngIf="recipientsInvalid">
        {{ recipientsErrorMessage }}
      </mat-error>
    </mat-form-field>

    <!-- Info text -->
    <div class="export-info-text">
      The export will be processed in the background. You will receive an email when it is ready, and you may track progress in the bottom left corner of the navigation panel.
    </div>
  </div>

  <!-- Actions -->
  <div class="dialog-actions">
    <lib-cdw-button
      (buttonClick)="onCancel()"
      level="secondary"
      mode="standard"
    >
      Cancel
    </lib-cdw-button>
    <lib-cdw-button
      (buttonClick)="onExport()"
      level="primary"
      mode="standard"
      [disabled]="exportForm.invalid || isSubmitting || cellCountExceeded"
    >
      {{ isSubmitting ? 'Exporting...' : 'Export' }}
    </lib-cdw-button>
  </div>
</div>
